import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { connect } from '../../react-redux';
import { closeModal } from '../../actions/modal';
import ConfirmationModal from './presenter';
var mapStateToProps = function mapStateToProps(state) {
  var modal = state.get('modal');
  return _objectSpread({
    modalOpen: !!modal.get('isOpen') && modal.get('isOpen') === modal.getIn(['options', 'title'])
  }, (modal.get('options') || Map()).toJS());
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: bindActionCreators(closeModal, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);